import { Badge, cn } from '@rematter/ui-web';
import { useAtom } from 'jotai';
import { LucideImage, LucideTag } from 'lucide-react';

import { EntityLoadRecord } from '../../_graphql/queryLoadListByEntity';
import * as state from '../../_state/entityLoads.state';

export type EntityLoadCardProps = { load: EntityLoadRecord };

export const EntityLoadCard = ({ load }: EntityLoadCardProps) => {
  const [loadId, setLoadId] = useAtom(state.$selectedLoadId);

  const isSelected = loadId === load.id;

  return (
    <div
      key={load.id}
      className={cn(
        '@EntityLoadCard',
        'flex cursor-pointer flex-col gap-1 rounded border border-neutral/20 bg-white p-2 text-sm text-neutral',
        isSelected && 'bg-primary text-white',
      )}
      onClick={() => setLoadId(load.id)}
    >
      <div className="flex items-center justify-between">
        <div className="font-semibold">#{load.loadNumber}</div>
        <Badge
          size="small"
          className={cn(isSelected && 'border-white/40 bg-white/20 text-white')}
        >
          {load.status}
        </Badge>
      </div>
      <div className="flex items-center gap-4 text-xs opacity-60">
        <div className="flex items-center gap-1">
          <LucideTag size={12} />
          {load.lineItems?.length ?? 0}
        </div>
        <div className="flex items-center gap-1">
          <LucideImage size={12} />
          {load.recyclerFiles?.length ?? 0}
        </div>
      </div>
    </div>
  );
};
